<template>
  <div class="content">
    <div class="content-top">
      <span style="font-size:16px" :class="type == 1? 'active' : ''" @click="changeType(1)">计划统计</span>
      <span style="font-size:16px" :class="type == 2? 'active' : ''" @click="changeType(2)">巡查库</span>
    </div>
    <div class="content-box">
      <planpro-view v-if="type == 1" @toAdd="receive" @toEdit="editFun"></planpro-view>
      <add-patrol @ddd="changeType(1)" v-else-if="type == 2" :flag="flag" :panId="id" :edit="edit" :obj="data"></add-patrol>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util'
  import planproView from '../../../views/project/new/components/planProViewWx.vue'
  import addPatrol from '../new/newAddPatrolWx.vue'

  export default {
    components: {
      planproView,
      addPatrol
      },
    data() {
      return {
        type: 1,
        flag: 2,
        id: '',
        data: '',
        edit: false
      }
    },
    created() {
      
    },
    mounted(){
      console.log(util.session.get('typeSS'))
      if(util.session.get('typeSS')!=''&&util.session.get('typeSS')!=null){
        this.type = util.session.get('typeSS')
        util.session.remove('typeSS')
      }
    },
    updated(){

      console.log(321)
      if(util.session.get('typeSS')!=''&&util.session.get('typeSS')!=null){
        this.type = util.session.get('typeSS')
        util.session.remove('typeSS')
      }
    },
    methods: {
      changeType(type){
        this.type = type
        this.flag = 2
        this.edit = false
        if(type==2){
          this.$router.push('/planPro')
        }
      },
      receive(id){
        this.type = 2
        this.flag = 1
        this.id = id
        this.edit = false
      },
      editFun(data){
        this.type = 2
        this.flag = 1
        this.data = data
        this.id = data.id
        this.edit = true
      }
    },
  }
</script>

<style scoped>
/* .content{
  padding: 1vh 1vw;
} */
.content-top{
  height: 56px;
  border-radius: 6px;
  background-color: #fff;
  text-align: left;
  margin-bottom: 8px;
}
.content-top > span {
  margin-left: 18px;
  padding-bottom: 18px;
  line-height: 56px;
  cursor: pointer;
}
.content-box{
  height: calc(100% - 64px);
  overflow: auto;
}
.active{
  border-bottom: 2px solid #4D6EB1;
}
</style>